<template>
  <div>
    <b-form>
    <div class="form-group flex-inline-form-lg">
        <b-input-group class="fill-width">
        <b-input-group-text slot="prepend">
            <i class="fa fa-search"></i>
        </b-input-group-text>
        <b-form-input
            style="height:auto;"
            type="text"
            placeholder="Search employee by name"
            @input="onChangeSearchQuery($event)"
            v-model="searchQuery"></b-form-input>
        </b-input-group>
        <b-input-group v-if="!hideCompanySelect">
        <company-multi-select
            :multiple="false"
            having="employee"
            :init-selection-id="companyIdQuery"
            @on-selected="onCompanySelected"
        />
        </b-input-group>
        <b-input-group>
        <b-form-select
            style="height:auto;"
            v-model="sortType"
            @change="onChangeSortType($event)"
            :options="sortOptions"></b-form-select>
        </b-input-group>
        <b-input-group>
        <b-button
            v-if="canICreateEmployee()"
            variant="success"
            @click="createEmployee()"
            title="Create new employee">
            New employee &nbsp;<i class="fa fa-plus"></i>
        </b-button>
        </b-input-group>
    </div>
    </b-form>
    <div v-if="isEmployeeInfoLoading">
    <div class="list-group mb-2" v-if="totalRows">
        <b-nav>
        <b-nav-item >Loading...</b-nav-item>
        </b-nav>
    </div>
    </div>
    <div v-else>
    <div class="list-group mb-2" v-if="totalRows">
        <b-nav>
        <b-nav-item
            v-show="count_default"
            @click="navSelected('DEFAULT')"
            :active="filterType === 'DEFAULT'">Default ({{count_default}})</b-nav-item>
        <b-nav-item
            v-show="count_loader"
            @click="navSelected('LOADER')"
            :active="filterType === 'LOADER'">Loader ({{count_loader}})</b-nav-item>
        <b-nav-item
            v-show="count_driver"
            @click="navSelected('DRIVER')"
            :active="filterType === 'DRIVER'">Driver ({{count_driver}})</b-nav-item>
        <b-nav-item
            v-show="count_operator"
            @click="navSelected('OPERATOR')"
            :active="filterType === 'OPERATOR'">Operator ({{count_operator}})</b-nav-item>
        </b-nav>
    </div>
    </div>
    <b-overlay :show="isEmployeeListLoading">
      <b-list-group class="no-box" v-if="totalRows">
          <b-list-group-item
          v-for="employee in employees"
          :key="`${employee.id}${Date.now()}`">
          <div class="pull-left">
              <router-link :to="'employees/' + employee.id">
              <strong>{{employee.name}}</strong>
              </router-link>
              <b-badge pill variant="success" v-if="employee.user">User</b-badge>
              <b-badge pill variant="primary" v-if="checkAppSelection(employee)">App Selection</b-badge>
              <p class="mb-1">{{employee.type}}</p>
              <small :title="formatDateTime(employee.created_at)">Created at: {{formatDateDistance(employee.created_at)}}</small>
          </div>
          <div v-if="hasAccessEmployee(employee)" class="pull-right">
              <b-button v-if="canIEditEmployee(employee)" variant="outline-primary" @click="editEmployee(employee.id)">
              <i class="fa fa-pencil-square-o"></i>&nbsp; Edit
              </b-button>
              <b-dropdown v-if="canIDeleteEmployee(employee)" variant="outline-primary" class="m-md-2">
              <i class="fa fa-gear" slot="button-content"></i>
              <b-dropdown-item v-if="employee.type === 'DRIVER'" @click.prevent="updateAppSelection(employee)">{{ getTitleAppSelection(employee) }}</b-dropdown-item>
              <b-dropdown-item @click.prevent="deleteEmployee(employee.id)" class="text-danger">Remove</b-dropdown-item>
              </b-dropdown>
          </div>
          </b-list-group-item>
      </b-list-group>
      <div style="height:150px;" v-if="isEmployeeListLoading && totalRows === 0"></div>
    </b-overlay>
    <b-pagination class="mt-3" align="center" size="md" :total-rows="totalRows" v-model="currentPage" :per-page="query_count" v-if="totalRows">
    </b-pagination>
    <b-alert show v-if="isFetched & totalRows === 0">There's no employee inside this company.</b-alert>
    <div>
      <b-modal
        id="delete_employee"
        title="Delete Employee"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="confirmedDeleteEmployee(deleteEmployeeId)">
        <p class="my-4">Are you sure want to delete this employee ?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import employeeMixin from '@/mixins/employee';
import routeQuery from '@/mixins/route_query';
import { isEmpty, uniqBy, get, debounce } from 'lodash';

import CompanyMultiSelect from '@/components/CompanyMultiSelect';

export default {
  name: 'employee_table',
  mixins: [dateMixin, employeeMixin, routeQuery],
  components: {
    CompanyMultiSelect,
  },
  props: {
    companyId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      deleteEmployeeId: null,
      loaded: false,
      disableEdit: false,
      disableCreate: false,
      searchQuery: '',
      filterType: 'DEFAULT',
      currentPage: 1,
      sortOptions: [
        { value: null, text: 'Sort By', disabled: true },
        { value: 'NAME.ASC', text: 'Name A-Z' },
        { value: 'NAME.DESC', text: 'Name Z-A' },
        { value: 'CREATED_AT.ASC', text: 'Newer' },
        { value: 'CREATED_AT.DESC', text: 'Older' },
      ],
      sortType: null,
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'employees', name: 'Employees' },
    ]);
    this.$store.commit('employees/CLEAR_QUERY');
    this.initFromUrl();
  },
  computed: {
    employees() {
      const employees = this.$store.getters['employees/employees'];
      return uniqBy(employees, 'id');
    },
    count_all() {
      return this.$store.getters['employees/count_all'];
    },
    count_default() {
      return this.$store.getters['employees/count_default'];
    },
    count_loader() {
      return this.$store.getters['employees/count_loader'];
    },
    count_driver() {
      return this.$store.getters['employees/count_driver'];
    },
    count_operator() {
      return this.$store.getters['employees/count_operator'];
    },
    query_count() {
      return this.$store.getters['employees/query_count'];
    },
    totalRows() {
      if (this.filterType === 'DEFAULT') {
        return this.count_default;
      } else if (this.filterType === 'LOADER') {
        return this.count_loader;
      } else if (this.filterType === 'DRIVER') {
        return this.count_driver;
      } else if (this.filterType === 'OPERATOR') {
        return this.count_operator;
      }
      return this.count_all;
    },
    isNotEmpty() {
      return !(this.count_all === 0 && this.searchQuery === '');
    },
    myAccess() {
      return this.$store.getters.userAccess;
    },
    is_data_loaded() {
      return this.$store.getters['employees/dataLoaded'];
    },
    loadDataEmployee() {
      return this.$store.getters['employees/loadEmployee'];
    },
    isEmployeeListLoading() {
      return this.isEmployeeInfoLoading || this.loadDataEmployee === 'LOADING';
    },
    isEmployeeInfoLoading() {
      return this.$store.getters['employees/employeeInfoState'] === 'LOADING';
    },
    isFetched() {
      return this.loadDataEmployee === 'LOADED';
    },
    hideCompanySelect() {
      return this.companyId !== '';
    },
    companyIdQuery() {
      return this.getRouteQuery('company_id', '');
    },
  },
  watch: {
    currentPage(newValue) {
      this.$store.commit('employees/SET_QUERY_PAGE', newValue);
      this.loadData();
    },
  },
  methods: {
    checkAppSelection(data) {
      const isDriver = data.type === 'DRIVER';
      const isActive = get(data, 'metadata.tms_app_selection') || false;
      return isActive && isDriver;
    },
    getTitleAppSelection(data) {
      const isActive = get(data, 'metadata.tms_app_selection') || false;
      const title = isActive ? 'Disable app selection' : 'Enable app selection';
      return title;
    },
    updateAppSelection(data) {
      const { id } = data;
      let { metadata } = data;
      const isActive = get(data, 'metadata.tms_app_selection') || false;
      const actionName = isActive ? 'Disable' : 'Enable';

      if (isEmpty(metadata)) {
        metadata = {};
      }

      metadata.tms_app_selection = !isActive;
      this.$swal({
        title: 'Are you sure',
        text: `Want to ${actionName} app for this employee ?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes ${actionName} it!`,
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          const payloadsMeta = {
            employeeId: id,
            metadata,
          };
          this.$store.dispatch('employees/UPDATE_APP_SELECTION', payloadsMeta).then((ok) => {
            if (ok) {
              this.$store.dispatch('employees/LOAD_DATA').then(() => {
                this.$swal('Updated', 'This employee\'s app successfully updated', 'success');
              });
            } else {
              this.$swal('Failed', 'Failed update data', 'error');
            }
          });
        }
      });
    },
    initFromUrl() {
      let fCompanyId = this.getRouteQuery('company_id');
      const sort = this.getRouteQuery('sort');
      const search = this.getRouteQuery('q');
      const type = this.getRouteQuery('type', 'DEFAULT');

      if (this.companyId !== '') {
        fCompanyId = this.companyId;
      }

      if (typeof fCompanyId !== 'undefined') {
        this.setCompanyId({ id: fCompanyId }, true);
      }
      if (sort !== undefined) {
        this.onChangeSortType(sort, true);
      }
      if (search !== undefined) {
        this.onChangeSearchQuery(search, true);
      }

      this.setQueryType(type);
    },
    setQueryType(type) {
      const qType = type || this.filterType;
      this.$store.dispatch('employees/LOAD_INFO').then(() => {
        const dataCount = [
          {
            key: 'DEFAULT',
            value: this.count_default,
          },
          {
            key: 'LOADER',
            value: this.count_loader,
          },
          {
            key: 'DRIVER',
            value: this.count_driver,
          },
          {
            key: 'OPERATOR',
            value: this.count_operator,
          },
        ];

        let matchType = dataCount.find(c => c.value && c.key === qType);
        if (typeof matchType === 'undefined') {
          matchType = dataCount.find(c => c.value);
        }
        this.filterType = matchType.key;
        this.$store.commit('employees/SET_QUERY_TYPE', matchType.key);

        this.loadData();
      });
    },
    navSelected(type) {
      this.filterType = type;
      const queryType = type;

      this.currentPage = 1;
      this.$store.commit('employees/SET_QUERY_PAGE', 1);
      this.$store.commit('employees/SET_QUERY_TYPE', queryType);
      if (type === 'DEFAULT') {
        this.removeRouteQuery('type');
      } else {
        this.setRouteQuery('type', type);
      }
      this.loadData();
    },
    updateSearchQuery: debounce((context, searchTerm) => {
      const searchQuery = searchTerm.trim();
      context.$store.commit('employees/SET_QUERY_SEARCH', searchQuery);
      context.loadData();
      context.$store.dispatch('employees/LOAD_INFO');
    }, 500),
    loadData() {
      return this.$store.dispatch('employees/LOAD_DATA');
    },
    editEmployee(employeeId) {
      this.$router.push(`/admin/employees/${employeeId}/edit`);
    },
    createEmployee() {
      this.$router.push('/admin/employees/create');
    },
    deleteEmployee(employeeId) {
      this.deleteEmployeeId = employeeId;
      this.$bvModal.show('delete_employee');
    },
    confirmedDeleteEmployee(employeeId) {
      this.$store.dispatch('employees/DELETE_DATA', employeeId).then((ok) => {
        if (ok) this.setQueryType();
      });
    },
    setCompanyId(selected, fromInit = false) {
      if (typeof selected !== 'undefined' && selected !== null) {
        this.$store.commit('employees/SET_COMPANY_ID', selected.id);
        const currId = this.getRouteQuery('company_id', '');
        if (!fromInit && selected.id !== currId) {
          this.setRouteQuery('company_id', selected.id);
        }
      } else {
        this.$store.commit('employees/SET_COMPANY_ID', null);
        if (!fromInit) {
          this.removeRouteQuery('company_id');
        }
      }
    },
    onCompanySelected(selected) {
      this.setCompanyId(selected);
      this.setQueryType();
    },
    onChangeSortType(newValue, fromInit = false) {
      if (!fromInit) {
        this.setRouteQuery('sort', newValue);
      }
      this.$store.commit('employees/SET_QUERY_SORT', newValue);
      this.sortType = newValue;

      if (!fromInit) {
        this.loadData();
      }
    },
    onChangeSearchQuery(newValue, fromInit = false) {
      this.$store.commit('employees/SET_QUERY_SEARCH', newValue);
      if (!fromInit) {
        if (!isEmpty(newValue)) {
          this.setRouteQuery('q', newValue);
        } else {
          this.removeRouteQuery('q');
        }
      }
      this.searchQuery = newValue;

      if (!fromInit) {
        this.updateSearchQuery(this, newValue);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/EmployeeTable.vue